import { GLOBAL_UPDATE_STATE,SET_WIZARD_VALUE,SEND_EMAIL_TO_CLIENT } from "./actionTypes";
import axios from 'axios';

export const globalUpdateState = content => ({
  type: GLOBAL_UPDATE_STATE,
  payload:{
    ...content
  }
});
export const setWizardValue = async (value,key,currentStep,stepsOpened) => {
  return {
    type: SET_WIZARD_VALUE,
    payload: {value,key,currentStep,stepsOpened}
  }
}
export const saveData = form => {
  // console.log('saving...',form)
    let formObj ={client: form.client,scenario: form.scenario,user: form.user,currentStep:form.currentStep,stepsOpened: form.stepsOpened};
    axios({
      method: 'post',
      url: '/92know/autosave',
      data: formObj
    }).then(response => {
      // console.log('post response',response);
    })
    .catch(ex =>{
      // console.log('post response',ex)
    });
  return {
    type: SET_WIZARD_VALUE,
    payload: form
  }; 
}
export const sendEmailToClient = (email,form) => {
  // console.log('saving...',form)
  return (dispatch) => {
      let formObj ={client: form.client,scenario: form.scenario,user: form.user};
      // console.log('sending email....',email)
      axios({
        method: 'post',
        url: '/92know/save/finish-later',
        data: {form:formObj,email:email}
      }).then(response => {
        console.log('post response',response);
        dispatch ({
          type: SEND_EMAIL_TO_CLIENT,
          payload: form
        });
      })
      .catch(ex =>{
        console.log('post response',ex)
      });
  };
}


